/**
 * Spawn a new window with the given URL
 * @param url URL
 * @returns Window object
 *
 * @example
 * ```ts
 * const newWindow = spawnNewWindow('https://example.com');
 * ```
 */
export const spawnNewWindow = (url: string) => {
	// it is what it is
	// eslint-disable-next-line security/detect-non-literal-fs-filename
	return window.open(url, '_blank');
};
